module.exports = __webpack_public_path__ + "static/media/Frame.7b913e53.svg";